import React from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { View, OrthographicCamera, Preload } from "@react-three/drei";

// Updated to remove transitions that cause grid bounce
export default function Scene({
  showModal = false,
  modalOpacity = 0,
  animationComplete = false,
}) {
  return (
    <>
      <Canvas
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          pointerEvents: showModal ? "none" : "none",
          // Use visibility instead of display to avoid layout shifts
          visibility: animationComplete ? "hidden" : "visible",
          // Remove opacity transitions that cause the grid bounce
          opacity: showModal
            ? modalOpacity < 0.85
              ? 1
              : 1 - (modalOpacity - 0.85) * 6.67
            : 1,
          // Remove the transition that causes the bounce
          // transition: "opacity 0.15s ease-out", // <-- REMOVED THIS LINE
        }}
        eventSource={showModal ? null : document.body}
      >
        <View.Port />
        <OrthographicCamera makeDefault position={[0, 0, 300]} zoom={1} />
        <Preload all />
      </Canvas>
    </>
  );
}
